<template>
  <div class="contents-wrap">
    <div class="box-titles">
      <a-breadcrumb>
        <a-breadcrumb-item>
          <a @click="queryByPid(0)">{{ $t("moduleTitles.root") }}</a>
        </a-breadcrumb-item>
        <a-breadcrumb-item
          v-for="(item, index) in folderDepthList"
          :key="index"
        >
          <a @click="queryByPid(item.id)">{{ item.name }}</a>
        </a-breadcrumb-item>
      </a-breadcrumb>
      <a-checkbox
        v-show="searchParam.pid !== 0 && dataSourse.length !== 0 && checkFilenameExists()"
        :checked="selectedAllbyFolder[searchParam.pid]"
        @change="handleSelectedAll"
      >
        選擇全部
      </a-checkbox>
      <a-button class="upload-btn" type="primary" @click="upload" v-if="!type"
        >{{$t('message.uploadBtn')}}<a-icon type="upload"
      /></a-button>
    </div>
    <div
      v-infinite-scroll="handleInfiniteOnLoad"
      class="demo-infinite-container"
      :infinite-scroll-disabled="busy"
      :infinite-scroll-distance="10"
    >
      <a-list
        :data-source="dataSourse"
        :grid="{ xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4 }"
      >
        <a-list-item slot="renderItem" slot-scope="item, index" :key="index">
          <div class="dir-wrapper" v-if="item.dir_id != undefined">
            <a-checkbox
              class="item-base"
              :ref="item.id"
              :value="item.id"
              :key="item.id"
              @change="onChange"
              :checked="checkedbyID[item.id]"
            >
              <div class="material-item">
                <div class="item-img">
                  <img :src="item.thumb_path"/>
                </div>
                <span class="item-name">{{ item.filename }}</span>
              </div>
            </a-checkbox>
          </div>
          <div class="dir-wrapper" v-else @click="queryByPid(item.id)">
            <a-icon
              type="folder"
              theme="filled"
              style="color: #1790ff; font-size: 40px; padding-left: 25px;"
            />
            <span class="dir-title">{{ item.name }}</span>
          </div>
        </a-list-item>
        <div v-if="loading && !busy" class="demo-loading-container">
          <a-spin />
        </div>
      </a-list>
    </div>
  </div>
</template>

<script>
import {
  getMaterialList as materialPageQuery,
  getFolderDepth,
} from "@/api/material";
import infiniteScroll from "vue-infinite-scroll";
import { mapGetters } from "vuex";

export default {
  name: "MaterialList",
  directives: { infiniteScroll },
  props: {
    type:{
      type:Number,
      default:0
    }
  },
  data() {
    return {
      loading: false,
      busy: false,
      folderDepthList: [],
      dataSourse: [],
      searchParam: {
        current_page: 1,
        per_page: 30,
        pid: 0,
        name: "",
        order: {},
      },
      selectedList: [],
      isFilterScence: false,
      // 選擇全部的勾選框
      selectedAllbyFolder:{},
      // 單一選項的勾選框
      checkedbyID:{}
    };
  },
  beforeMount() {},
  watch: {},
  computed: {
    ...mapGetters(["vrbase", "userInfo"]),
  },
  mounted() {
    if (this.$attrs.isFilterScence) {
      this.isFilterScence = this.$attrs.isFilterScence;
    }
  },
  methods: {
    loadData() {
      this.loading = true;
      materialPageQuery(this.searchParam)
        .then((res) => {
          this.loading = false;
          if (res.code === 1) {
            let lastPage = Math.ceil(
              res.data.total / this.searchParam.per_page
            );
            if (this.searchParam.current_page > lastPage) {
              this.busy = true;
              return false;
            }
            this.searchParam.current_page++;
            // vr編輯需要過濾已經選擇的場景
            if (this.isFilterScence) {
              this.handleVrEditScenes(res.data.records);
            } else {
              this.dataSourse = [...this.dataSourse, ...res.data.records];
            }
            this.busy = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
      getFolderDepth({ id: this.searchParam.pid }).then((res) => {
        if (res.code === 1) {
          this.folderDepthList = res.data;
        }
      });
    },
    resetLoad() {
      this.searchParam.current_page = 1;
      this.dataSourse = [];
      this.loadData();
    },
    queryByPid(pid) {
      this.searchParam.current_page = 1;
      this.searchParam.pid = pid;
      this.dataSourse = [];
      this.loadData();
      this.$emit("dirChange", pid);
    },
    onChange(e) {
      const pid = this.searchParam.pid;
      if (e.target.checked) {
        let selectInfo = {};
        this.dataSourse.filter((item) => {
          if (item.dir_id != undefined && item.id === e.target.value) {
            selectInfo = item;
          }
        });
        this.selectedList.push(selectInfo);
        // 使用 $set 方法才有辦法觸發渲染更新
        // 讓 checkedbyID 加上 dataSourse 的 ID 為名的屬性，值為 checked
        this.$set(this.checkedbyID, e.target.value, e.target.checked);
        // 計算此資料夾目前有多少個被勾選
        let count = 0;
        this.dataSourse.map((item)=>{
          if(this.checkedbyID[item.id] === true){
            count++
          }
        })
        // 使用單選選擇到全部時，要把「選擇全部」這個按鈕勾選
        if(count == this.dataSourse.length){
          this.$set(this.selectedAllbyFolder, pid, e.target.checked);
        }
      } else {
        this.selectedList.splice(
          this.selectedList.findIndex((item) => item.id === e.target.value.id),
          1
        );
        this.$set(this.checkedbyID, e.target.value, e.target.checked);
        // 單項取消選取時，要把「選擇全部」這個狀態取消
        this.$set(this.selectedAllbyFolder, pid, e.target.checked);
      }
      this.$emit("selected", this.selectedList);
    },
    handleInfiniteOnLoad() {
      this.loadData();
    },
    handleSearch(name) {
      this.searchParam.current_page = 1;
      this.searchParam.name = name;
      this.dataSourse = [];
      this.loadData();
    },
    // 過濾已經選擇的場景
    handleVrEditScenes(listData) {
      // 獲取已有的場景的pid
      let pidList = [];
      for (let key in this.vrbase.scenes) {
        pidList.push(this.vrbase.scenes[key].pid);
      }
      const filterData = [];
      for (let i = 0; i < listData.length; i++) {
        const temp = listData[i];
        if (pidList.includes(temp.id)) continue;
        filterData.push(temp);
      }
      this.dataSourse = [...this.dataSourse, ...filterData];
    },
    // 選擇全部
    handleSelectedAll(e) {
      // 把 :ref="item.id" 所產生的 $refs 物件進行篩選
      const refArray = Object.values(this.$refs).filter(refItem => refItem !== undefined);
      // 計算有沒有全選
      let trueCount = 0
      // 計算是否從未被點選過
      let undefinedCount = 0
      // 計算是否有被點選過 但現在是未點選狀態
      let falseCount = 0
      
      refArray.forEach((item)=>{
        if(this.checkedbyID[item.value] == true){
          trueCount++
        }else if(this.checkedbyID[item.value] == false){
          falseCount++
        }else{
          undefinedCount++
        }
      })
      // 全選的取消
      if(trueCount == refArray.length){
        refArray.forEach((item)=>{
          item.$el.click();
        })
      }else{
        // 需要點選 從未點選的選項
        if(undefinedCount !==0){
          refArray.forEach((item)=>{
            if(this.checkedbyID[item.value] == undefined){
              item.$el.click();
            }
          })
        // 需要點選 有被選過但現在是未點選的選項
        }else if(falseCount !==0){
          refArray.forEach((item)=>{
            if(this.checkedbyID[item.value] == false){
              item.$el.click();
            }
          })
        }
      }
      // 依據不同的資料夾 pid 處理各資料夾的全選按鈕狀態
      const pid = this.searchParam.pid;
      // 更新 selectedAllbyFolder 的狀態
      this.$set(this.selectedAllbyFolder, pid, e.target.checked);
    },
    upload() {
      this.$emit("showUpload");
    },
    // 檢查物件是否包含 filename 屬性on
    // 用於判斷是否顯示選擇全部的按鈕
    checkFilenameExists() {
      return this.dataSourse.every(item => item.filename !== undefined);
    },
  },
};
</script>

<style lang="less" scoped>
.dir-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 20px;
}
.dir-wrapper:hover {
  cursor: pointer;
  color: #1890ff;
}
@media (max-width: 767px) {
  .dir-wrapper {
    padding: 20px;
  }
}
.card-wrapper {
  width: 100px;
  height: 100px;
}
.contents-wrap {
  .upload-btn {
    position: absolute;
    top: -6px;
    right: 0;
    flex-shrink: 0;
  }
  .box-titles {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    margin-bottom: 15px;
  }
}
.demo-infinite-container {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  overflow: auto;
  padding: 8px 24px;
  height: 400px;
}
.demo-loading-container {
  position: absolute;
  bottom: 40px;
  width: 100%;
  text-align: center;
}
.item-base {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
}
.material-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
}
.item-img {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  margin-right: 5px;
}
.item-img img {
  width: 100%;
}
.item-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100px;
}
.dir-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
